import React, { useEffect, useState } from "react";
import "./freetrail.css";

import TrialStart from "./TrialStart";
import TrialEmail from "./TrialEmail";
import TrialOtp from "./TrialOtp";
import { useDispatch, useSelector } from "react-redux";
import { clearError, googleTrialLogin } from "../../redux/reducers/authSlice";
import {snackbarContext} from '../helpers/Snakbar'
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../helpers/Loader";
import { TabTitle } from "../helpers/GeneralFunctions";


const FreeTrial = () => {
   TabTitle("Free Trial")
  const setStateSnackbarContext=React.useContext(snackbarContext)
     const {error:backendError,loading}=useSelector((state)=>state.auth)
  const [step, setStep] = useState("start");
   const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
   const themeId = queryParams.get("theme");
  // const [email, setEmail] = useState("");
  const [utm, setUtmValues] = useState({
    utm_source: "unknown",
    utm_medium: "unknown",
    utm_campaign: null
  });

    // ✅ READ UTM ONLY ONCE
 
const dispatch=useDispatch()
const navigate=useNavigate()


  const handleGoogle = (credentialResponse) => {
    // Start Google authentication
    // On success -> dashboard
    dispatch(googleTrialLogin({credential:credentialResponse.credential,setStateSnackbarContext,navigate,themeId,utm}))
    

  };


  const handleEmail = () => {
    setStep("email");
  };


  const handleEmailContinue = () => {

     setStep("otp");
    // Send OTP API here

    // setStep("otp");
  };



  
     useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    setUtmValues({
      utm_source: searchParams.get("utm_source")?.toLowerCase() || "unknown",
      utm_medium: searchParams.get("utm_medium")?.toLowerCase() || "unknown",
      utm_campaign: searchParams.get("utm_campaign")?.toLowerCase() || null
    });
  }, []); // 👈 EMPTY dependency = run once

 

  if(backendError){
      setStateSnackbarContext(
        true,
        backendError,
        "warning"
      )
      dispatch(clearError())
    }

    if(loading){
      return <Loader/>
    }
 


  return (
    <div className="trail-container">

      {step === "start" && (
        <TrialStart
          onGoogle={handleGoogle}
          onEmail={handleEmail}
        />
      )}

      {step === "email" && (
        <TrialEmail
          onContinue={handleEmailContinue}
          onBack={() => setStep("start")}
          theme={themeId}
          utm={utm}
        />
      )}

      {step === "otp" && (
        <TrialOtp
          onContinue={handleEmailContinue}
          onBack={() => setStep("email")}
        />
      )}


    </div>
  );
};

export default FreeTrial;